import { render, staticRenderFns } from "./reactions.vue?vue&type=template&id=95ee98a0&scoped=true&"
import script from "./reactions.vue?vue&type=script&lang=js&"
export * from "./reactions.vue?vue&type=script&lang=js&"
import style0 from "./reactions.vue?vue&type=style&index=0&id=95ee98a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ee98a0",
  null
  
)

export default component.exports